var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiamondSimple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 29,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#diamond-simple_svg__a)",
  fillRule: "evenodd",
  d: "M35.989 10.231a3.24 3.24 0 0 1-.954 2.149L18.864 28.454a1.2 1.2 0 0 1-.846.348h-.036a1.2 1.2 0 0 1-.846-.348L.965 12.38A3.24 3.24 0 0 1 .01 10.23z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#diamond-simple_svg__b)",
  fillRule: "evenodd",
  d: "M35.995 10.2H.005a3.25 3.25 0 0 1 .678-2.154L5.92 1.278A3.31 3.31 0 0 1 8.531 0h18.937a3.31 3.31 0 0 1 2.61 1.278l5.239 6.768q.172.226.3.462c.072.138.138.282.186.426.15.408.216.84.192 1.267",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#diamond-simple_svg__c)",
  fillRule: "evenodd",
  d: "M35.995 10.23H24.276l4.59-6.594 1.44-2.064 3.787 4.897 1.224 1.578c.498.648.72 1.422.678 2.184",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#diamond-simple_svg__d)",
  fillRule: "evenodd",
  d: "M11.724 10.23H.005a3.28 3.28 0 0 1 .678-2.183l1.224-1.578 3.786-4.897.918 1.314.522.75 4.573 6.565z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#diamond-simple_svg__e)",
  fillRule: "evenodd",
  d: "m11.693 10.231 6.289 18.571 6.294-18.57z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#diamond-simple_svg__f)",
  fillRule: "evenodd",
  d: "M24.274 10.232 17.984 0l-6.29 10.232z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "diamond-simple_svg__a",
  x1: 18,
  x2: 18,
  y1: 10.231,
  y2: 28.802,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A4EEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.732,
  stopColor: "#02C0FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#27A6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "diamond-simple_svg__b",
  x1: 18,
  x2: 18,
  y1: 0,
  y2: 10.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#A4EEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.237,
  stopColor: "#A0EDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.346,
  stopColor: "#93E9FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.457,
  stopColor: "#7FE3FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.569,
  stopColor: "#62DBFE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.682,
  stopColor: "#3CD0FD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.795,
  stopColor: "#0FC4FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.824,
  stopColor: "#02C0FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#27A6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "diamond-simple_svg__c",
  x1: 30.138,
  x2: 30.138,
  y1: 1.572,
  y2: 10.231,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A4EEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.732,
  stopColor: "#02C0FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#27A6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "diamond-simple_svg__d",
  x1: 5.862,
  x2: 5.862,
  y1: 1.572,
  y2: 10.231,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A4EEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.732,
  stopColor: "#02C0FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#27A6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "diamond-simple_svg__e",
  x1: 17.985,
  x2: 17.985,
  y1: 7.474,
  y2: 27.454,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A4EEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.476,
  stopColor: "#02C0FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.787,
  stopColor: "#27A6FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "diamond-simple_svg__f",
  x1: 17.983,
  x2: 17.983,
  y1: 0,
  y2: 10.232,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.127,
  stopColor: "#A4EEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.676,
  stopColor: "#02C0FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.881,
  stopColor: "#27A6FF"
})))));
export default SvgDiamondSimple;